<template>
  <div id="app">
    <!-- <div v-html="metaTag"></div> -->
    <router-view />
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
// import dingding from '@/assets/font/DingTalk JinBuTi.ttf'
export default {
  name: 'app',
  data() {
  return {
    // metaTag: '<meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1"/>'
  }
 },
 created() {
    // const meta = document.createElement('meta');
    // meta.httpEquiv = 'Content-Security-Policy';
    // meta.content = 'upgrade-insecure-requests';
    // document.head.appendChild(meta);
  }
  // components: {
  //   HelloWorld
  // }
}
</script>

<style lang="scss">

html,
body,
p,
ul,
li {
  margin: 0;
  padding: 0;
  color: #333639;
}
.textDetail_Cont div{
    margin: 0 !important;
    padding: 0 !important;
}
.textDetail_Cont p{
    margin-bottom: 12px !important;
}
ul,
li {
  list-style: none;
}

html {
  //  text-align: center;
  // padding: 10px;
}

.pageW{
  width: 1170px;
  margin: 0 auto;
}

.overf {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.newsUl {
  width: 100%;
  li {
    height: 35px;
    width: 100%;
    cursor: pointer;
      span{
        display: inline-block;
       
        max-width: 96%;
         position: relative;
         &:hover::after{
        content: "";
            width: 100%;
            height: 1px ;
            background: #333639;
            position: absolute;
            bottom: 0px;
            left: 0px;
            right: 0;
      }
      }
      
    
    &:not(:first-child) {
      position: relative;
      padding-left: 14px;
      font-size: 15px;
      color: #686B6C;

      &::before {
        content: "";
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: #010101;
        position: absolute;
        left: 0px;
        top: 9px;
      }
    }

    &:first-child {
      color: #323639;
      font-weight: bold;
      font-size: 18px;
      height: 40px;
      // text-align: center;
    }
  }
}
.newsUlT{
  li{
    &:first-child {
      text-align: center;
    }
  }
}
.news_r_tit{
          margin: 20px 0 20px 0;
          color: #323639;
          padding-left: 10px;
          font-size: 18px;
          font-weight: bold;
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;
          overflow: hidden;
          span{
            display: inline-block;
            margin-right: 10px;
            flex-shrink: 0;
            cursor: pointer;
          }
          img{
            flex: 1;
            width: auto;
            height: 15px;
          }
          &::before{
            content: "";
            width: 4px;
            height: 80%;
            background: #E00001;
            position: absolute;
            left: 0;
            top: 10%;     
          }
        }
        .newsList{
         display: flex;
        //  margin: 2px 0;
        &:not(:last-child){
          margin-bottom: 8px;
        }
         justify-content: space-between;
        img{
          width: 144px;
          height: 81px;
          border-radius: 4px;
          object-fit: fill;
          margin-right: 10px;
        }
        div{
          flex: 1;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 6px 0;
          .overf{
            width: 100%;
          }
          &:hover{
            cursor: pointer;
            p{
             &:first-child{
              font-weight: bold;
             }
            } 
          }
         
          p{
            
            &:last-child{
              color: #979A9C;
              font-size: 12px;
            }
            
          }
        }
      }
.pageBanner{
  width: 100%;
  margin: 20px 0 0 0;
}
.cordG{
  background: #F9F9F9;
}
.pagination{
  margin-top: 20px;
  // text-align: center;
}
// 分页
.el-pagination{
  .el-pager .number{
    min-width: 38px;
      background: #efefef;
      margin-right: 10px;
      font-size: 13px;
      font-weight: 500;
      border-radius: 3px;
      &:hover{
        background: #ee1c24 !important;
        color: #fff !important;
      }
    }
    .btn-prev{
      margin-right: 10px;
    }
    .btn-prev,.btn-next{
      background: #efefef;
      &:hover{
        color: #ee1c24 !important;
      }
    }
    .el-pagination button:disabled {
      background-color: #efefef !important;
    }
    .active{
      background: #ee1c24 !important;
      color: #fff !important;
    }
    .el-input__inner:hover,.el-input__inner:focus{
      border-color: #ee1c24;
    }
}
.levelBannerImgs{
  width: 100%;
  height: 70px;
  margin-top: 10px;
  margin-bottom: 20px;
  .el-carousel__container{
    height: 70px;
  }
  img{
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}
.loadingInfo{
    margin: 120px 0;
    color: #aaa;
    font-size: 14px;
    img{
        width: 80px;
        margin-bottom: 20px;
    }
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue